import { createElement } from "react";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { tryFind, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { ta, t } from "../Lang.js";
import { Export_selectHint, Export_noArrangement, Export_csvDesc, Export_csvTitle, Export_csvSection, Export_seatingDiagramDesc, Export_seatingDiagram, Export_floorPlanDesc, Export_floorPlan, Export_fullLayoutDesc, Export_fullLayout, Export_nameCardsDesc, Export_nameCards, Export_tableCardsDesc, Export_tableCards, Export_pdfSection, Export_preview, Export_arrangementStats, Export_arrangementScore, Step_cards, Export_layout, Export_theme, Export_Layout_vintageClassic, Export_Layout_boldStatement, Export_Layout_handwritten, Export_Layout_cleanModern, Export_Layout_elegantSerif, Export_Theme_midnightFestive, Export_Theme_gardenBotanical, Export_Theme_corporateNavy, Export_Theme_romanticBlush, Export_Theme_classicWarmth, Export_download } from "../Shared/Tr.js";
import { append, singleton, collect, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { Msg } from "../App/Messages.js";
import { helpIcon } from "./Components.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.28.0/String.js";

function exportButton(label, description, iconClass, onClick) {
    let elems_3, elems_2, elems, elems_1;
    return createElement("div", createObj(ofArray([["className", "export-card card"], (elems_3 = [createElement("div", createObj(ofArray([["className", "export-card-body"], (elems_2 = [createElement("div", createObj(ofArray([["className", "export-card-icon"], (elems = [createElement("span", {
        className: iconClass,
        children: label,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "export-card-info"], (elems_1 = [createElement("h4", {
        children: label,
    }), createElement("p", {
        className: "text-muted text-sm",
        children: description,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("button", {
        className: "btn btn-primary btn-sm",
        children: t(Export_download),
        onClick: (_arg) => {
            onClick();
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function exportUrl(arrangementId, format, theme, layout) {
    return `/api/export/${arrangementId}?format=${format}&theme=${theme}&layout=${layout}`;
}

const themeSwatches = ofArray([[0, Export_Theme_classicWarmth, "#c06a45", "#d4a24e"], [1, Export_Theme_romanticBlush, "#c9707d", "#d4a373"], [2, Export_Theme_corporateNavy, "#1e3a5f", "#c5985e"], [3, Export_Theme_gardenBotanical, "#3d6b4f", "#d4a373"], [4, Export_Theme_midnightFestive, "#7b2d8e", "#e6a817"]]);

const layoutCards = ofArray([[0, Export_Layout_elegantSerif, "Playfair Display"], [1, Export_Layout_cleanModern, "DM Sans"], [2, Export_Layout_handwritten, "Dancing Script"], [3, Export_Layout_boldStatement, "Oswald"], [4, Export_Layout_vintageClassic, "EB Garamond"]]);

function themePicker(selectedTheme, dispatch) {
    let elems_1, elems;
    return createElement("div", createObj(ofArray([["className", "theme-picker"], (elems_1 = [createElement("label", {
        className: "picker-label",
        children: t(Export_theme),
    }), createElement("div", createObj(ofArray([["className", "picker-row"], (elems = toList(delay(() => collect((matchValue) => {
        const idx = matchValue[0] | 0;
        return singleton(createElement("button", {
            className: (idx === selectedTheme) ? "theme-swatch selected" : "theme-swatch",
            title: t(matchValue[1]),
            onClick: (_arg) => {
                dispatch(new Msg(92, [idx]));
            },
            style: {
                background: ((("linear-gradient(135deg, " + matchValue[2]) + " 50%, ") + matchValue[3]) + " 50%)",
            },
        }));
    }, themeSwatches))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function layoutPicker(selectedLayout, dispatch) {
    let elems_2, elems_1;
    return createElement("div", createObj(ofArray([["className", "layout-picker"], (elems_2 = [createElement("label", {
        className: "picker-label",
        children: t(Export_layout),
    }), createElement("div", createObj(ofArray([["className", "picker-row"], (elems_1 = toList(delay(() => collect((matchValue) => {
        let elems;
        const idx = matchValue[0] | 0;
        return singleton(createElement("button", createObj(ofArray([["className", (idx === selectedLayout) ? "layout-card selected" : "layout-card"], ["onClick", (_arg) => {
            dispatch(new Msg(93, [idx]));
        }], (elems = [createElement("span", {
            className: "layout-sample",
            style: {
                fontFamily: matchValue[2],
            },
            children: "Sarah",
        }), createElement("span", {
            className: "layout-name",
            children: t(matchValue[1]),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    }, layoutCards))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function view(state, dispatch) {
    let elems_7;
    const selectedArrangement = tryFind((s) => s.IsSelected, state.Arrangements);
    return createElement("div", createObj(ofArray([["className", "export-panel"], (elems_7 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "flex items-center gap-sm mb-2"], (elems = [createElement("h3", {
            children: t(Step_cards),
        }), helpIcon(() => {
            dispatch(new Msg(268, ["06", undefined]));
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_2, tupledArg, tupledArg_1, elems_1;
            const matchValue = selectedArrangement;
            if (matchValue != null) {
                const sol = matchValue;
                return append(singleton(createElement("div", createObj(ofArray([["className", "export-arrangement-info mb-2"], (elems_2 = [createElement("span", {
                    className: "badge",
                    children: (tupledArg = Export_arrangementScore(toText(printf("%.1f"))(sol.Score)), ta(tupledArg[0], tupledArg[1])),
                }), createElement("span", {
                    className: "text-muted text-sm",
                    style: {
                        marginLeft: 8,
                    },
                    children: (tupledArg_1 = Export_arrangementStats(int32ToString(sol.HardViolations), int32ToString(sol.SoftViolations)), ta(tupledArg_1[0], tupledArg_1[1])),
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let elems_3;
                    return append(singleton(createElement("div", createObj(ofArray([["className", "export-style-pickers mb-2"], (elems_3 = [themePicker(state.ExportTheme, dispatch), layoutPicker(state.ExportLayout, dispatch)], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                        let elems_4;
                        return append(singleton(createElement("div", createObj(ofArray([["className", "export-preview mb-2"], (elems_4 = [createElement("label", {
                            className: "picker-label",
                            children: t(Export_preview),
                        }), createElement("iframe", {
                            className: "export-preview-frame",
                            src: exportUrl(sol.Id, "name-cards-html", state.ExportTheme, state.ExportLayout),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => append(singleton(createElement("h4", {
                            className: "export-section-title",
                            children: t(Export_pdfSection),
                        })), delay(() => {
                            let elems_5;
                            return append(singleton(createElement("div", createObj(ofArray([["className", "export-grid"], (elems_5 = [exportButton(t(Export_tableCards), t(Export_tableCardsDesc), "export-icon-pdf", () => {
                                window.open(exportUrl(sol.Id, "table-cards", state.ExportTheme, state.ExportLayout), '_blank');
                            }), exportButton(t(Export_nameCards), t(Export_nameCardsDesc), "export-icon-pdf", () => {
                                window.open(exportUrl(sol.Id, "name-cards", state.ExportTheme, state.ExportLayout), '_blank');
                            }), exportButton(t(Export_fullLayout), t(Export_fullLayoutDesc), "export-icon-pdf", () => {
                                window.open(exportUrl(sol.Id, "full-layout", state.ExportTheme, state.ExportLayout), '_blank');
                            }), exportButton(t(Export_floorPlan), t(Export_floorPlanDesc), "export-icon-pdf", () => {
                                window.open(exportUrl(sol.Id, "floor-plan", state.ExportTheme, state.ExportLayout), '_blank');
                            }), exportButton(t(Export_seatingDiagram), t(Export_seatingDiagramDesc), "export-icon-pdf", () => {
                                window.open(exportUrl(sol.Id, "seating-diagram", state.ExportTheme, state.ExportLayout), '_blank');
                            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => append(singleton(createElement("h4", {
                                className: "export-section-title mt-2",
                                children: t(Export_csvSection),
                            })), delay(() => {
                                let elems_6;
                                return singleton(createElement("div", createObj(ofArray([["className", "export-grid"], (elems_6 = [exportButton(t(Export_csvTitle), t(Export_csvDesc), "export-icon-csv", () => {
                                    window.open(exportUrl(sol.Id, "csv", state.ExportTheme, state.ExportLayout), '_blank');
                                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                            }))));
                        }))));
                    }));
                }));
            }
            else {
                return singleton(createElement("div", createObj(ofArray([["className", "export-no-arrangement card"], (elems_1 = [createElement("p", {
                    className: "text-muted",
                    children: t(Export_noArrangement),
                }), createElement("p", {
                    className: "text-muted text-sm",
                    children: t(Export_selectHint),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

